import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'

import withRouter from '../../Common/withRouter'

const SaleRow = (props) => {

    const [quantity, setQuantity] = useState(props.row.quantity)
    const [rowTotal, setRowTotal] = useState(null)

    const handleBlur = (e, setValue) => {
        if (e.target.value === '' || e.target.value === '0' || e.target.value <= 1) {
            setValue(1);
        }
        if (e.target.value >= props.row.qtyStock) {
            setValue(props.row.qtyStock);
        }
    };

    useEffect(() => {

        if (quantity >= 0) {
            let disc = (props.row.unitPrice * quantity) - (((props.row.unitPrice * quantity)*props.row.discount)/100);
            setRowTotal(disc);
        }
    }, [quantity]);


    useEffect(() =>{
        if (rowTotal) {
            if (quantity > 0) {
                if (props.isValidate) {
                    let object = {
                        productId: props.row.productId,
                        name: props.row.name,
                    }
                    props.updateRow(object)
                } else {
                    let object = {
                        value: props.row.value,
                        quantity: quantity,
                        rowTotal: rowTotal
                    }
                    props.updateRow(object)
                }
            }
        }
    },[rowTotal])

  return (
    < >
        <td style={{ width: "5%" }}>{props.index+1}</td>
        <td style={{ width: "30%", minWidth: '260px'  }}>{props.row.label}</td>
        <td style={{ width: "15%", minWidth: '130px', textAlign: 'right'}}>{props.row.unitPrice}</td>
        <td style={{ width: "15%", minWidth: '130px', textAlign: 'center' }}>{props.row.discount}</td>
        <td style={{ width: "15%", minWidth: '130px' }}>
            <input
                type="number"
                className="form-control m-0"
                value={quantity}
                onChange={(e) => setQuantity(Number(e.target.value))} onBlur={(e) => handleBlur(e, setQuantity)}
                aria-label="Text input with checkbox"
                disabled = {props.isWatch || (props.row.type === 'Service') ? true : false}

            />
        </td>
        <td style={{ width: "10%", minWidth: '86px' }}>{rowTotal}</td>
        {!props.isWatch && (props.isAuthor && (props.sale && props.sale.id)) || !(props.sale && props.sale.id) ?
            <td style={{ width: "10%", minWidth: '86px' }} className="delete-action" onClick={() => props.deleteRow(props.row) }>
                <button
                    style={{ border: 'none', background: 'none', color: '#dc3545', cursor: 'pointer' }}
                    className="delete-action-btn">
                    <i className="fa-solid fa-trash-can"></i>
                </button>
            </td>
            :
            <><td style={{ width: "10%", minWidth: '86px' }}></td></>
        }
    </>
  )
}

export default withRouter(withTranslation()(SaleRow))
